import React, { useContext } from "react"
import styled, { ThemeContext } from "styled-components"
import Text from "@airasia/phoenix-components/components/Text"
import Theme from "@airasia/phoenix-components/components/Theme"
import Link from "@airasia/phoenix-components/components/Link"
import Image from "@airasia/phoenix-components/components/Image"
import Title from "@airasia/phoenix-components/components/Title"

import PropTypes from "prop-types"
import {
  DEFAULT_THEME,
  ARR_COLORS,
  Themes,
} from "@airasia/phoenix-components/components/Theme/constant"
import { AIRASIA_WHITE_LOGO } from "./constant"

const BannerWrapper = styled.div`
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ? theme.colors[backgroundColor] : theme.colors.primary};

  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? `column` : `row`)};
  align-items: ${({ isMobile }) => (isMobile ? `normal` : `center`)};
  padding: ${({ isMobile }) => (isMobile ? `20px` : `20px 20px 20px 100px`)};
`

BannerWrapper.displayName = "BannerWrapper"

const StyledContainerContent = styled.div`
  margin-left: ${({ isMobile }) => (isMobile ? `0px` : `50px`)};
  // margin-top: ${({ isMobile }) => (isMobile ? `20px` : `0px`)};

  #app-banner-title {
    margin-top: 10px;
  }

  #mobile-view-deeplink-container {
    display: none;
  }

  ${({ isMobile }) =>
    isMobile &&
    `
  #barcode-image {
    display: none
  }

  #app-banner-title {
    margin-top: 0px;
  }

  #app-banner-description {
    margin-top: 10px;
  }

  #mobile-view-deeplink-container {
    display: flex;
  }
  `}
`

StyledContainerContent.displayName = "StyledContainerContent"

const MobileViewDeeplinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
`

const DeeplinkImage = styled.div`
  width: 50%;
`

const AppCtaBanner = props => {
  const {
    title,
    description,
    appBarcodeSrc,
    theme,
    backgroundColor,
    isMobile,
    accessible,
    logoImageSrc,
    logoImageRedirectUrl,
  } = props
  const themeContext = useContext(ThemeContext)

  const getMain = () => {
    return (
      <BannerWrapper
        theme={themeContext}
        backgroundColor={backgroundColor}
        isMobile={isMobile}
      >
        {!isMobile && (
          <Image
            src={appBarcodeSrc}
            alt={title}
            height="120px"
            width="120px"
            accessible={accessible}
          />
        )}

        <StyledContainerContent isMobile={isMobile}>
          <Link
            href={logoImageRedirectUrl}
            theme={theme}
            accessible={accessible}
            customProperties={{
              id: "barcode-image",
            }}
          >
            <Image
              src={logoImageSrc}
              alt="airasia.com logo"
              placeHolderBackground="none"
            />
          </Link>

          <Title
            color="default"
            type="h3"
            marginBottom="mini"
            theme={theme}
            accessible={accessible}
            customProperties={{
              id: "app-banner-title",
            }}
          >
            {title}
          </Title>
          <Text
            color="default"
            accessible={accessible}
            customProperties={{
              id: "app-banner-description",
            }}
          >
            {description}
          </Text>
          <MobileViewDeeplinkContainer id="mobile-view-deeplink-container">
            <DeeplinkImage>
              <Link href="https://airasia.onelink.me/F4uy/8bab4b1" target="tab">
                <Image
                  src="https://a.staticaa.com/images/logo/app-store-badge.png"
                  alt="download from app store image"
                  placeHolderBackground="none"
                />
              </Link>
            </DeeplinkImage>
            <DeeplinkImage>
              <Link href="https://airasia.onelink.me/F4uy/8bab4b1" target="tab">
                <Image
                  src="https://a.staticaa.com/images/logo/google-play-badge.png"
                  alt="download from play store image"
                  placeHolderBackground="none"
                />
              </Link>
            </DeeplinkImage>
          </MobileViewDeeplinkContainer>
        </StyledContainerContent>
      </BannerWrapper>
    )
  }

  return themeContext ? getMain() : <Theme theme={theme}>{getMain()}</Theme>
}

AppCtaBanner.propTypes = {
  theme: PropTypes.oneOf(Themes),
  accessible: PropTypes.bool,
  isMobile: PropTypes.bool,

  title: PropTypes.string,
  description: PropTypes.string,
  appBarcodeSrc: PropTypes.string,
  backgroundColor: PropTypes.oneOf(ARR_COLORS),

  logoImageSrc: PropTypes.string,
  logoImageRedirectUrl: PropTypes.string,
}

AppCtaBanner.defaultProps = {
  theme: DEFAULT_THEME,
  accessible: true,
  isMobile: false,
  backgroundColor: "primary",
  appBarcodeSrc:
    "https://a.staticaa.com/images/web-apps/content-pages/library/airasiacom-qrcode.png",
  logoImageSrc: AIRASIA_WHITE_LOGO,
  logoImageRedirectUrl: "https://www.airasia.com/en/gb/",
}

export default AppCtaBanner
